import PackageEnum from "../enum/PackageEnum";
import {isPackageTypeChat, isPackageTypeInternet, isUnitTypeHour, isUnitTypeMinutes} from "./CheckUtil";
import verifyTypeEnum from "../enum/VerifyTypeEnum";

export default class ContentManager {

    user = null;
    t = null;
    i18n = null;

    constructor(user: null, t: null, i18n: null) {
        this.user = user;
        this.t = t;
        this.i18n = i18n;
    }

    homeContent = () => {
        if (this.user?.verifyType === verifyTypeEnum.OTHER_LOGIN)
            return this.t("class.content.scratch_and_promotion_card");
        let result = "";
        if (this.user?.business) result = "class.content.business";
        else result = "class.content.economy";
        if (this.user?.package === PackageEnum.CLASSIC)
            return this.t(`${result}.classic`);
        else if (this.user?.package === PackageEnum.CLASSIC_PLUS)
            return this.t(`${result}.classic_plus`);
        else if (this.user?.package === PackageEnum.ELITE)
            return this.t(`${result}.elite`);
        else if (this.user?.package === PackageEnum.ELITE_PLUS)
            return this.t(`${result}.elite_plus`);
        else {
            if (this.user?.quotas?.nonPurchase?.length > 0) {
                return this.t(`${result}.class`);
            } else if (this.user?.quotas?.purchase?.length > 0)
                return this.t(`${result}.buy`);
            else return this.t('class.content.login_success');
        }
    }

    homePurchaseTitle = (value) => {
        if (value.isUnlimited) {
            if (isPackageTypeInternet(value.packageType))
                return this.t('purchase_package.internet_package_unlimited')
            else if (isPackageTypeChat(value.packageType))
                return this.t('purchase_package.message_package_unlimited')
            else
                return this.t('purchase_package.all_package_unlimited')
        } else return value.amount + " " + value.unit + " " + this.t('purchase_package.internet_package')
    }

    homePackageName = () => {
        let result = "";
        if (this.user?.business) result = "Business";
        else result = "Economy";
        if (this.user?.package === PackageEnum.CLASSIC)
            result += " - Miles&Smiles Classic";
        else if (this.user?.package === PackageEnum.CLASSIC_PLUS)
            result += " - Miles&Smiles Classic Plus";
        else if (this.user?.package === PackageEnum.ELITE)
            result += " - Miles&Smiles Elite";
        else if (this.user?.package === PackageEnum.ELITE_PLUS)
            result += " - Miles&Smiles Elite Plus";
        return result;
    }

    homeRemainingUsageTitle = (value) => {
        if (value.isUnlimited) return this.t('package_unlimited')
        else {
            if (isUnitTypeHour(value.unit)) {
                return value.amount + " " + this.t('hour')
            } else if (isUnitTypeMinutes(value.unit)) {
                return value.amount + " " + this.t('minutes')
            }
            return value.amount + " " + value.unit
        }
    }

    homeCampaignPackageTitle = (value) => {
        if (value.info_tr !== null || value.info_en !== null)
            return /tr/.test(this.i18n.language.toLowerCase()) ? value.info_tr : value.info_en;
        return this.homePurchaseTitle(value);
    }

    homeCampaignPackageDescription = (value) => {
        if (value.info_desc_tr !== null || value.info_desc_en !== null)
            return /tr/.test(this.i18n.language.toLowerCase()) ? value.info_desc_tr : value.info_desc_en;
        return this.homeRemainingUsageTitle(value);
    }
}

